import type {ListOptionWithCount} from 'shells/select-option-components/option-with-count';

export function getAudienceError(audience?: ListOptionWithCount | null): string | null | undefined {
    if (audience && audience.count === 0 && !audience.requiresSync && !audience.isSyncing) {
        return 'Select an audience with at least 1 subscriber';
    }

    return null;
}
